import { HourglassTop, CheckCircle, Policy } from '@mui/icons-material';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const DonorConfig: any = {
    private: 'Private',
    public: 'Public',
    donor: 'Donor',
    'csr-cell': 'CSR Cell',
    'CSR Cell': 'CSR Cell',
    "central-psu": 'Central PSU',
    "state-psu": 'State PSU',
    partenership: 'Partenership',
    hospital_user: 'Hospital',
    government: 'Government',
    "trust": "Trust",
    "charity": "Charity",
    semi_government: 'Semi-Government',
    proprietorship: 'Proprietorship',
    "society-trust": 'Society / Trust',
    'govt-undertaking': 'Government Undertaking',
    individual :"Individual",
    Individual :"Individual",
    "non-company": "Non-Company",
    others: 'Others',
    'autonomous-body': 'Statutory Body',
    'satutory-body': 'Statutory Body',
    section: 'Section-8',
    company_psu: 'Company / PSU',
    'donor-foundation': 'Donor Foundation',
    autonomous_body: 'Statutory Body',
    statutory_body: 'Statutory Body',
    government_user :'Government Department',
    partnership :'Partnership',
    implementing_agency :'Implementing Agency',
}

export const userStatusConfig: Record< string, { label: string; color: "warning" | "success" | "error"; icon: React.ReactNode; allowDelete: boolean } > = {
    pending: {
        label: "Pending",
        color: "warning",
        icon: <HourglassTop />,
        allowDelete: true, 
    },
    approved: {
        label: "Approved",
        color: "success",
        icon: <CheckCircle />,
        allowDelete: false,
    },
    rejected: {
        label: "Rejected",
        color: "error",
        icon: <HighlightOffIcon fontSize="small" />, 
        allowDelete: false,
    },
    compliance: {
        label: "Compliance Pending",
        color: "error",
        icon: <Policy />,
        allowDelete: false,
      },
};

export const getButtonStyles = () => ({
    background: "#013E5E",
    color: "#fff",
    borderRadius: "8px",
    transition: "background 0.3s ease-in-out",
    "&:hover": {
        background: "#013E5E",
    },
    "&:disabled": {
        border: "1px solid #013E5E",
        backgroundColor: "#fff",
        color: "#013E5E",
        cursor: "not-allowed",
    },
});
